<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.64 33.52">
    <g id="Calque_2" data-name="Calque 2">
      <g id="ƒŒƒCƒ_1" data-name="ƒŒƒCƒ„[ 1">
        <path
          class="cls-1"
          d="M15.76,16.31H12.21v-5a4.07,4.07,0,0,1,1-2.79,4.66,4.66,0,1,0-6.89,0,4.25,4.25,0,0,1,1.06,2.85v4.95H3.88A3.17,3.17,0,0,0,.71,19.48v2.33H18.92V19.48A3.16,3.16,0,0,0,15.76,16.31Z"
        />
        <path
          class="cls-2"
          d="M18.92,22.53H.71A.71.71,0,0,1,0,21.81V19.48A3.88,3.88,0,0,1,3.88,15.6H6.72V11.36A3.56,3.56,0,0,0,5.84,9a5.36,5.36,0,0,1-1.4-3.61A5.44,5.44,0,0,1,6.15,1.44,5.38,5.38,0,0,1,13.79,9a3.4,3.4,0,0,0-.87,2.31V15.6h2.84a3.88,3.88,0,0,1,3.88,3.88v2.33A.72.72,0,0,1,18.92,22.53ZM1.43,21.1H18.21V19.48A2.45,2.45,0,0,0,15.76,17H12.21a.72.72,0,0,1-.72-.72v-5A4.84,4.84,0,0,1,12.73,8a3.92,3.92,0,0,0,1-2.92,4,4,0,0,0-3.65-3.68A4,4,0,0,0,5.87,5.38,3.9,3.9,0,0,0,6.9,8a5,5,0,0,1,1.25,3.33v4.95a.72.72,0,0,1-.72.72H3.88a2.45,2.45,0,0,0-2.45,2.45Z"
        />
        <path
          class="cls-2"
          d="M9.82,7.08a1.71,1.71,0,1,1,1.7-1.7A1.71,1.71,0,0,1,9.82,7.08Zm0-2.45a.75.75,0,0,0,0,1.5.75.75,0,0,0,0-1.5Z"
        />
        <path
          class="cls-2"
          d="M18.92,21.1H.71a.71.71,0,0,0-.71.71v11a.71.71,0,0,0,.71.72H18.92a.72.72,0,0,0,.72-.72v-11A.71.71,0,0,0,18.92,21.1Zm-.71,11H16.3V27.31a.48.48,0,1,0-1,0v4.78H13.41v-2.8a.48.48,0,0,0-.95,0v2.8H7.91V26.25a.48.48,0,0,0-1,0v5.84H4.53V28.81a.48.48,0,1,0-1,0v3.28H1.43V22.53H18.21Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconTrade.vue',
};
</script>

<style scoped>
.cls-1 {
  fill: #f9802f;
}
.cls-2 {
  fill: #162b46;
}
</style>
